module.exports = __webpack_public_path__ + "img/1F622.6d801f1f.svg";